import * as React from 'react';
import * as firebase from 'firebase/app';
import { Dispatch } from 'react-redux';
import { Table, Card, Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AppState, Category } from 'src/store';
import { actions as toast } from 'src/toast';
import ButtonGroup from 'antd/lib/button/button-group';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    navigate: (route: string) => {
      dispatch(push(route));
    },
    onEdit: (id: string) => { dispatch(push(`/categories/edit/${id}`)); },
    onDelete: async (id: string) => {
      const ref = firebase.firestore().collection('categories');
      if (id) {
        const doc = ref.doc(id)
        await doc.delete()
        dispatch(toast.success('Category is deleted successfully.'));
      }
    },
  };
};

interface P {
  navigate: (route: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => Promise<void>;
}
type S = {
  status: 'none' | 'loading';
} | {
  status: 'loaded';
  data: Category[];
}
class CategoryList extends React.Component<P, S> {
  columns: ColumnProps<Category>[];
  subscription: Subscription;

  constructor(props: P) {
    super(props);
    this.state = { status: 'none' };
    this.subscription = new Subscription();
  }

  componentDidMount() {
    this.setState({ status: 'loading' });
    const query = firebase.firestore()
      .collection('categories')
      .orderBy("parentName").orderBy("name")

    this.subscription = querySnapShot$(query)
      .subscribe(qsn => {
        const data = qsn.docs.map(d => ({ id: d.id, ...d.data() } as Category));
        this.setState({ status: 'loaded', data });
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleOnAdd = () => {
    const { navigate } = this.props;
    navigate(`/categories/create`);
  }

  render() {
    const { onEdit, onDelete } = this.props;

    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
      render: (text: string, record: Category, index: number) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
    },
    {
      title: 'Parent Name',
      dataIndex: 'parentName',
      key: 'parentName',
      width: '15%',
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '15%',
      render: (text: string, record: Category) => {

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="Click to edit category">
              <Button
                icon="edit"
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => { onEdit(record.id); }}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to delete this category?"
              // tslint:disable-next-line:jsx-no-lambda
              onConfirm={() => { onDelete(record.id); }}
              // onCancel={cancel} 
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title="Click to delete category">
                <Button icon="delete" />
              </Tooltip>
            </Popconfirm>

          </ButtonGroup>
        );
      }
    }
    ];

    const data = this.state.status === 'loaded' ? this.state.data : [];

    const dataSource = data.map((d, i) => ({
      no: i + 1,
      ...d
    }));

    return (
      <Card
        loading={this.state.status === 'loading'}
        title="Category List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
        extra={
          <Button type="primary" icon="plus" onClick={this.handleOnAdd}>
            Create
              </Button>
        }>
        <Table
          columns={this.columns}
          dataSource={dataSource}
          pagination={false}
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default connect(st => ({}), mapDispatchToProps)(CategoryList);



// WEBPACK FOOTER //
// ./src/categories/containers/CategoryList.tsx